export default function acceptTerms() {

  const termsAccepted = document.getElementById('terms_accepted');
  const acceptTerms = document.getElementById('accept_terms');

  termsAccepted.addEventListener('change', (e) => {
    acceptTerms.disabled = !e.target.checked;
  });
};